import { createEffect, createEvent } from 'effector';
import { metricsApi } from './api';
import { SetMetrics } from './types';

export const metricsTimeout = 100;

export const setMetricsListOpened = createEvent<SetMetrics>();
export const setMetricsListRequested = createEvent<SetMetrics>();
export const setMetricsFilterCreated = createEvent<SetMetrics>();
export const setMetricsFilterDeleted = createEvent<SetMetrics>();

export const fxSetMetrics = createEffect<SetMetrics, void, Error>().use(metricsApi.set);
